export default __webpack_public_path__ + "static/media/Mystic's Straps of the Aureate.3728d5e5.jpg";